import { render } from "./OrderServiceCreate.vue?vue&type=template&id=96c9e0c6"
import script from "./OrderServiceCreate.vue?vue&type=script&lang=js"
export * from "./OrderServiceCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__